/**
 * UKC Weight Pull percent/time helpers.
 * Percent is highest_weight / dog_weight * 100, truncated to two decimals
 * (no rounding). Time is stored as seconds and displayed as SS.TT.
 */

export const truncateToTwoDecimals = (n: number): number => {
  if (!Number.isFinite(n)) {
    return n;
  }
  return Math.trunc(n * 100) / 100;
};

export const calculateWeightPullPercent = (
  highestWeight?: number,
  dogWeight?: number
): number | undefined => {
  if (
    highestWeight == null ||
    dogWeight == null ||
    !Number.isFinite(highestWeight) ||
    !Number.isFinite(dogWeight) ||
    highestWeight <= 0 ||
    dogWeight <= 0
  ) {
    return undefined;
  }
  return truncateToTwoDecimals((highestWeight / dogWeight) * 100);
};

export const formatWeightPullPercent = (percent?: number): string => {
  if (percent == null || !Number.isFinite(percent)) {
    return "";
  }
  return truncateToTwoDecimals(percent).toFixed(2);
};

export const formatWeightPullTime = (seconds?: number): string => {
  if (seconds == null || !Number.isFinite(seconds) || seconds <= 0) {
    return "";
  }
  return truncateToTwoDecimals(seconds).toFixed(2);
};
